module.exports = __webpack_public_path__ + "static/media/linkedin.8586a5ab.svg";